import React, { FC, useState } from "react";
import { Formik } from "formik";
import AppointmentAIReportReviewEditDialogFormik from "./AppointmentAIReportReviewEditDialogFormik";
import useFormikProps from "./useFormikProps";
import useTranslations from "./useTranslations";
import { AppointmentAIReportReviewEditDialogProps } from "./useAppointmentAIReportReviewEditDialog";

const AppointmentAIReportReviewEditDialog: FC<
  AppointmentAIReportReviewEditDialogProps
> = ({ isOpened, report, mode, handleClose, onCancelClick, onSave }) => {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const { translations } = useTranslations({
    mode,
    status: report?.status || undefined,
    report,
  });

  const formikProps = useFormikProps({
    report,
    translations,
    onSave: async (values) => {
      try {
        setErrorMessage(null);
        if (!report) {
          throw new Error("Report not found");
        }
        await onSave(values);
      } catch (error) {
        setErrorMessage((error as Error).message);
        throw error;
      }
    },
    handleClose,
  });

  return (
    <Formik {...formikProps}>
      <AppointmentAIReportReviewEditDialogFormik
        isOpened={isOpened}
        title={translations.title || ""}
        onCancel={onCancelClick}
        errorMessage={errorMessage}
        translations={translations}
      />
    </Formik>
  );
};

export default AppointmentAIReportReviewEditDialog;
